<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="金卡交换配置" @back="goBack" /></span>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="extraData" label="选择金卡1">
            <template slot-scope="scope">
              <el-select v-model="scope.row.cards1" multiple filterable placeholder="请选择" style="width: 600px;">
                <el-option
                  v-for="item in cards"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="extraData" label="选择金卡2">
            <template slot-scope="scope">
              <el-select v-model="scope.row.cards2" multiple filterable placeholder="请选择" style="width: 600px;">
                <el-option
                  v-for="item in cards"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:RewardGoldenCardTradeEdit:add']" style="margin-top: 10px" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getActivtyList, updateActivtyRewardConfData } from '@/api/config/activity-cfg'
import { getCardCfgAllList } from '@/api/config/card-cfg'

export default {
  name: 'RewardGoldenCardTradeEdit',
  data() {
    return {
      isOnline: 0,
      aid: 0,
      type: '',
      formData: [],
      cards: []
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getCardCfg()
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const card1 = this.formData[0].cards1
      const card2 = this.formData[0].cards2
      if (!card1) {
        this.msgError('请选择金卡1')
        return
      }
      if (!card2) {
        this.msgError('请选择金卡2')
        return
      }
      if (card1.filter(value => card2.includes(value)).length > 0) {
        this.msgError('金卡1与金卡2不能一致')
        return
      }
      const data = JSON.stringify(this.formData[0])
      updateActivtyRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.formData = []
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          const reward_conf = res.data.list[0].reward_conf
          if (reward_conf) {
            this.formData.push(reward_conf)
          } else {
            this.formData.push({ cards1: [], cards2: [] })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getCardCfg() {
      getCardCfgAllList({ id: 0 }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            if (!(item.grade !== 2 && item.ciid < 10000)) {
              let gname = '普通卡组'
              if (item.ciid > 10000) {
                gname = '限时卡组'
              }
              this.cards.push({ label: item.ciid + '-' + item.ci_name + '-' + gname, value: item.ciid, disabled: false })
            }
          })
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
